<template>
  <div class="about detail-card">
    <div class="title">
      <p class="body-menu caps align-left">{{lesson.label}}</p>
      <p class="name align-left" v-html="lesson.title"></p>
    </div>
    <p class="description captions align-left" v-html="lesson.description"></p>
    <IconText class="light" icon="time" :text="`${lesson.estimateOfCompletionTime} to complete`"/>
  </div>
</template>

<script>
  import IconText from "@/components/lessons/card/IconText"
  export default {
    name: 'About',
    components: {
      IconText
    },
    props: {
      lesson: {
        type: Object,
        default: function () {
          return {}
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "@/styles";
  .about {
    padding: 40px 100px;
    @media (max-width: 768px) {
      padding: 30px;
    }
    @media (max-width: 414px) {
      padding: 22px 18px;
    }
    .title {
      color: $primary;
      margin-bottom: 30px;
      p {
        margin-bottom: 0;
        margin-top: 0;
        &.name {
          font-size: 20px;
          font-weight: 500;
        }
      }
    }
    .description {
      margin-top: 0;
      width: 100%;
    }
    .light {
      font-weight: 300;
    }
  }
</style>

<style lang="scss">
.about.detail-card .name i {
  color: #4632FF;
}

.about.detail-card .description i {
  color: #4632FF;
}
</style>